import { CardBox } from '@aibees/shared/components';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CardBox)`
  @media (min-width: 600px) {
    & .MuiTab-root {
      margin-right: ${(p) => p.theme.spacing(1.5)} !important;
    }
  }
`;

export const Input = styled(TextField)`
  width: 100%;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: ${(p) => p.theme.spacing(0.5)};
    background: ${(p) => p.theme.palette.common.white};
    gap: 1;
    border: none;
  }
  fieldset {
    border-color: ${(p) => p.theme.palette.grey[300]};
  }
  input {
    background: ${(p) => p.theme.palette.common.white};
    font-size: ${(p) => p.theme.typography['body5' as 'caption']};
  }
`;
